<template>
  <aside class="app-menu">
    <div class="app-menu__brand">
      <p class="app-menu__eyebrow">ODIN</p>
      <p class="app-menu__title">Panel operativo</p>
      <p class="app-menu__copy">Navegación central para la operación activa y el seguimiento del estado operativo.</p>
    </div>

    <div class="app-menu__section">
      <p class="app-menu__section-label">Administración</p>
      <ul class="app-menu__list">
        <li v-if="hasPermission('menuCLIENT')">
          <a
            href="#"
            class="app-menu__link"
            :class="{ 'app-menu__link--active': isActive('/') }"
            @click.prevent="clickMenu('/')"
          >
            <span class="app-menu__icon"><i class="fa fa-home"></i></span>
            <span>Clientes</span>
          </a>
        </li>
        <li v-if="canManageUsers()">
          <a
            href="#"
            class="app-menu__link"
            :class="{ 'app-menu__link--active': isActive('/tracking') }"
            @click.prevent="clickMenu('/tracking')"
          >
            <span class="app-menu__icon"><i class="fa fa-list-check"></i></span>
            <span>Seguimiento General</span>
          </a>
        </li>
        <li v-if="canManageUsers()">
          <a
            href="#"
            class="app-menu__link"
            :class="{ 'app-menu__link--active': isActive('/users') }"
            @click.prevent="clickMenu('/users')"
          >
            <span class="app-menu__icon"><i class="fa fa-users"></i></span>
            <span>Usuarios</span>
          </a>
        </li>

        <li v-if="hasPermission('menuCONF')">
          <a
            href="#"
            class="app-menu__link"
            :class="{ 'app-menu__link--active': isActive('/settings') }"
            @click.prevent="clickMenu('/settings')"
          >
            <span class="app-menu__icon"><i class="fa fa-gears"></i></span>
            <span>Configuración</span>
          </a>
        </li>
      </ul>
    </div>

    <div class="app-menu__section">
      <p class="app-menu__section-label">Operación</p>
      <ul class="app-menu__list">
        <li v-if="canManageUsers()">
          <a
            href="#"
            class="app-menu__link"
            :class="{ 'app-menu__link--active': isBulkImportsActive() }"
            @click.prevent="clickMenu('/bulk-imports')"
          >
            <span class="app-menu__icon"><i class="fa fa-file-upload"></i></span>
            <span>Cargas masivas</span>
          </a>
        </li>

        <li>
          <a
            href="#"
            class="app-menu__link"
            :class="{ 'app-menu__link--active': isActive('/about') }"
            @click.prevent="clickMenu('/about')"
          >
            <span class="app-menu__icon"><i class="fa fa-flask"></i></span>
            <span>Estado operativo</span>
          </a>
        </li>
      </ul>
    </div>
  </aside>
</template>
<script>
import auth from '@/auth/index'
export default {
  methods: {
    hasPermission (code) {
      return auth.hasUserPermission(code)
    },
    canManageUsers () {
      return auth.canManageUsers()
    },
    isBulkImportsActive () {
      return this.$route.path === '/bulk-imports' || this.$route.path.startsWith('/bulk-imports/')
    },
    isActive (path) {
      if (path === '/') {
        return this.$route.path === '/' || this.$route.path === '/#' || this.$route.name === 'Home'
      }
      return this.$route.path === path
    },
    async clickMenu (url) {
      this.$router.push(url).catch(() => {})
    }
  }
}
</script>
<style scoped>
.app-menu {
  position: sticky;
  top: 0.75rem;
  max-height: calc(100vh - 1.5rem);
  margin: 0.75rem 0 0.75rem 0.75rem;
  padding: 1.25rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.48);
  border-radius: 28px;
  background: linear-gradient(180deg, rgba(255, 252, 247, 0.9), rgba(243, 236, 226, 0.78));
  box-shadow: 0 24px 60px rgba(43, 34, 24, 0.08);
  backdrop-filter: blur(16px);
  text-align: left;
  overflow: auto;
}

.app-menu__brand {
  padding: 0.2rem 0.15rem 1.2rem;
  border-bottom: 1px solid rgba(161, 136, 94, 0.12);
}

.app-menu__eyebrow {
  margin: 0;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.24rem;
  color: rgba(36, 31, 25, 0.46);
}

.app-menu__title {
  margin: 0.7rem 0 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #221d18;
}

.app-menu__copy {
  margin: 0.45rem 0 0;
  color: rgba(36, 31, 25, 0.62);
  font-size: 0.9rem;
  line-height: 1.6;
}

.app-menu__section {
  margin-top: 1.25rem;
}

.app-menu__section-label {
  margin: 0 0 0.7rem;
  padding: 0 0.15rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.22rem;
  text-transform: uppercase;
  color: rgba(36, 31, 25, 0.46);
}

.app-menu__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.app-menu__list li + li {
  margin-top: 0.35rem;
}

.app-menu__link {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  min-height: 46px;
  padding: 0.75rem 0.85rem;
  border-radius: 16px;
  color: rgba(36, 31, 25, 0.78);
  font-size: 0.96rem;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;
}

.app-menu__link:hover,
.app-menu__link:focus {
  color: #211c17;
  background: rgba(255, 255, 255, 0.56);
  transform: translateX(1px);
}

.app-menu__link--active {
  background: linear-gradient(135deg, #28211b 0%, #4a3c2b 100%);
  color: #f7f0e5;
  box-shadow: 0 14px 28px rgba(54, 42, 28, 0.18);
}

.app-menu__link--active:hover,
.app-menu__link--active:focus {
  color: #f7f0e5;
  background: linear-gradient(135deg, #28211b 0%, #4a3c2b 100%);
  transform: none;
}

.app-menu__link--muted {
  opacity: 0.6;
}

.app-menu__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.56);
  color: inherit;
  flex-shrink: 0;
}

.app-menu__link--active .app-menu__icon {
  background: rgba(255, 255, 255, 0.12);
}

@media (max-width: 1215px) {
  .app-menu {
    margin-left: 0;
    border-radius: 24px;
    padding: 1rem 0.9rem;
  }
}
</style>

